// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-actions {
  justify-content: flex-end;
}

.mat-dialog-container {
  max-width: 50%;
  margin: auto;
}

@media (max-width: 500px) {
  .mat-dialog-container {
    max-width: 100vw;
  }
}
.task-list {
  height: auto;
  overflow-y: auto;
}

.mat-dialog-content {
  overflow: auto !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
